import React from 'react'
import { UseFormRegisterReturn, FieldValues, Path } from 'react-hook-form'

import { FieldWrapper, validationRules } from '..'
import { FiveStageInputFieldProps } from './FiveStageInputField.types'
import { FiveStageInput } from '../../../ui-elements/FiveStageInput'

export const FiveStageInputField = <TFormValues extends Record<string, unknown> = Record<string, unknown>>(
  props: FiveStageInputFieldProps<TFormValues>,
) => {
  const { label, name, register, required } = props

  return (
    <Component
      {...props}
      registration={{
        ...register(name, {
          required: required && validationRules.required(label),
        }),
      }}
    />
  )
}

type ComponentProps<TFormValues extends FieldValues> = Omit<FiveStageInputFieldProps<TFormValues>, 'register'> & {
  className?: string
  registration: Partial<UseFormRegisterReturn<Path<TFormValues>>>
}

const Component = <TFormValues extends Record<string, unknown>>(props: ComponentProps<TFormValues>) => (
  <FieldWrapper
    label={props.label}
    error={props.error}
    isRequired={props.required}
    column={props.column}
    labelClassName={props.labelClassName}
    fieldClassName={props.fieldClassName}
  >
    <FiveStageInput
      {...props.registration}
      className={`${props.className}__input ${props.error ? 'error' : ''}`}
      disabled={props.disabled}
    />
  </FieldWrapper>
)
